import React from "react";
import { Link } from "@/i18n/router";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";
import { useLang } from "@/i18n/LanguageContext";
import { PLATFORM_URL } from "@/lib/api";

// Recurring flagship CTA banner: "Discover AstroLife™ AI Governance OS"
export function PlatformCta({ variant = "dark" }) {
  const isDark = variant === "dark";
  const { tr } = useLang();
  return (
    <section className={isDark ? "bg-navy" : "bg-light-grey"} aria-labelledby="platform-cta-heading">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16">
        <Reveal>
          <div className="relative overflow-hidden rounded-3xl border border-astro-blue/30 bg-gradient-to-br from-astro-dark to-navy-surface p-10 md:p-16">
            <div className="absolute inset-0 bg-grid opacity-20" aria-hidden="true" />
            <div className="radial-glow absolute inset-0" aria-hidden="true" />
            <div className="relative flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
              <div className="max-w-2xl">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-astro-light">{tr("Flagship Platform")}</p>
                <h2 id="platform-cta-heading" className="mt-3 font-heading text-3xl md:text-4xl font-bold tracking-tight text-white">
                  {tr("Discover AstroLife™ AI Governance OS")}
                </h2>
                <p className="mt-4 text-base md:text-lg leading-relaxed text-silver/70">
                  {tr("Verifiable AI Governance for Enterprises, Governments and Critical Infrastructure. Inventory, risk, lifecycle, audit readiness and evidence in a single sovereign operating system.")}
                </p>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row lg:flex-col">
                <a
                  href={PLATFORM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="cta-launch-platform"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-astro-blue px-8 py-4 font-semibold text-white hover:bg-astro-light transition-colors"
                >
                  {tr("Launch Platform")} <ArrowUpRight className="h-4 w-4" />
                </a>
                <Link
                  to="/private-beta"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border-2 border-white/20 px-8 py-4 font-semibold text-white hover:bg-white/10 transition-colors"
                >
                  {tr("Request Private Beta")} <ArrowRight className="h-4 w-4" />
                </Link>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
